const IconCaretDown = (): JSX.Element => {
  return (
    <>
      <path
        d="M19.5556 8.90283L17.7278 7L11.7778 13.1808L5.82778 7L4 8.90283L11.7778 17L19.5556 8.90283Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconCaretDown;
